(function () {
  'use strict';

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', count > 0);
    });
  }

  function openCartDrawer() {
    var trigger = document.querySelector('.js-drawer-open-cart');
    if (trigger) trigger.click();
  }

  function init() {
    var addonEl = document.querySelector('[data-product-addon]');
    if (!addonEl) return;

    var checkbox = addonEl.querySelector('.product-addon__checkbox');
    if (!checkbox) return;

    var addonVariantId = parseInt(checkbox.getAttribute('data-addon-variant'), 10);
    if (!addonVariantId) return;

    // Which product was this add-on ticked on? Stamped onto the add-on line
    // (as an "Applies to" property) so packing knows which item it belongs to.
    var addonForProduct = (checkbox.getAttribute('data-addon-for') || '').trim();

    // ── Artwork upload (laser marking) ─────────────────────────────────
    // Files upload to a Google Apps Script web app that drops them into a
    // Drive subfolder, then returns a link per file. The links get attached
    // to the add-on cart line so each order carries its own artwork link.
    var driveUrl     = addonEl.getAttribute('data-addon-drive-url') || '';
    var driveFolder  = addonEl.getAttribute('data-addon-folder') || '';
    // Order-line property name the artwork links are stamped under. Lets the
    // same code serve different services (laser → "Laser file", UV → "UV file").
    var uploadProperty = addonEl.getAttribute('data-addon-property') || 'Laser file';
    var uploadWrap   = addonEl.querySelector('[data-addon-upload]');
    var fileInput    = addonEl.querySelector('[data-addon-file-input]');
    var dropBtn      = addonEl.querySelector('[data-addon-drop]');
    var fileListEl   = addonEl.querySelector('[data-addon-file-list]');
    var uploadErrorEl = addonEl.querySelector('[data-addon-upload-error]');
    var uploadErrorDefault = uploadErrorEl ? uploadErrorEl.textContent : '';
    var uploadedLinks = [];   // ["logo.svg: https://drive…", …]
    var pendingUploads = [];  // in-flight upload promises

    function showUploadError() {
      if (uploadErrorEl) {
        uploadErrorEl.textContent = uploadErrorDefault;
        uploadErrorEl.hidden = false;
      }
      if (uploadWrap) {
        uploadWrap.classList.add('is-missing');
        uploadWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function clearUploadError() {
      if (uploadErrorEl) uploadErrorEl.hidden = true;
      if (uploadWrap) uploadWrap.classList.remove('is-missing');
    }

    // Cart-level failure (part sold out, variant gone, cart busy). Shown in the
    // add-on box so the customer knows nothing was added.
    function addError(msg) {
      var el = addonEl.querySelector('[data-addon-add-error]');
      if (!el) {
        el = document.createElement('p');
        el.className = 'product-addon__upload-error';
        el.setAttribute('data-addon-add-error', '');
        addonEl.appendChild(el);
      }
      el.hidden = false;
      el.textContent = msg || 'Sorry, that could not be added to your cart. Please try again.';
    }

    function clearAddError() {
      var el = addonEl.querySelector('[data-addon-add-error]');
      if (el) el.hidden = true;
    }

    function syncUploadVisibility() {
      if (!uploadWrap) return;
      uploadWrap.hidden = !checkbox.checked;
      if (!checkbox.checked) clearUploadError();
    }
    checkbox.addEventListener('change', syncUploadVisibility);
    syncUploadVisibility();

    // ── Accepted artwork types ───────────────────────────────
    // The input's accept attribute only governs the browse dialog. Drag and
    // drop bypasses it completely, which is how photographs were reaching us.
    // Every path into uploadFiles is checked here instead.
    var ALLOWED_EXT = ['svg', 'ai', 'eps', 'pdf', 'png'];

    function fileExt(name) {
      var m = /\.([a-z0-9]+)$/i.exec(name || '');
      return m ? m[1].toLowerCase() : '';
    }

    function rejectFile(name, ext) {
      var isJpeg = (ext === 'jpg' || ext === 'jpeg');
      var row = document.createElement('div');
      row.className = 'product-addon__file is-error';
      var nameEl = document.createElement('span');
      nameEl.className = 'product-addon__file-name';
      nameEl.textContent = name;
      var statusEl = document.createElement('span');
      statusEl.className = 'product-addon__file-status';
      statusEl.textContent = isJpeg ? 'JPEGs are not accepted' : 'File type not accepted';
      var removeEl = document.createElement('button');
      removeEl.type = 'button';
      removeEl.className = 'product-addon__file-remove';
      removeEl.setAttribute('aria-label', 'Remove file');
      removeEl.innerHTML = '&times;';
      removeEl.addEventListener('click', function () { row.remove(); });
      row.appendChild(nameEl);
      row.appendChild(statusEl);
      row.appendChild(removeEl);
      if (fileListEl) fileListEl.appendChild(row);
      if (uploadErrorEl) {
        uploadErrorEl.textContent = isJpeg
          ? 'JPEGs are not accepted. Laser marking needs vector artwork: SVG, AI, EPS, PDF or PNG.'
          : 'That file type is not accepted. Please upload SVG, AI, EPS, PDF or PNG.';
        uploadErrorEl.hidden = false;
      }
      if (uploadWrap) uploadWrap.classList.add('is-missing');
    }

    function renderRow(name) {
      var row = document.createElement('div');
      row.className = 'product-addon__file';
      var nameEl = document.createElement('span');
      nameEl.className = 'product-addon__file-name';
      nameEl.textContent = name;
      var statusEl = document.createElement('span');
      statusEl.className = 'product-addon__file-status';
      statusEl.textContent = 'Uploading…';
      var removeEl = document.createElement('button');
      removeEl.type = 'button';
      removeEl.className = 'product-addon__file-remove';
      removeEl.setAttribute('aria-label', 'Remove file');
      removeEl.innerHTML = '&times;';
      row.appendChild(nameEl);
      row.appendChild(statusEl);
      row.appendChild(removeEl);
      if (fileListEl) fileListEl.appendChild(row);
      return {
        el: row,
        setDone: function (link) {
          row.classList.add('is-done');
          statusEl.textContent = 'Uploaded ✓';
          if (link) { uploadedLinks.push(link); }
          removeEl.addEventListener('click', function () {
            if (link) { uploadedLinks = uploadedLinks.filter(function (l) { return l !== link; }); }
            row.remove();
          });
        },
        setError: function () {
          row.classList.add('is-error');
          statusEl.textContent = 'Upload failed — please try again';
          removeEl.addEventListener('click', function () { row.remove(); });
        }
      };
    }

    function readAsPayload(file) {
      return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onload = function (ev) {
          var base64 = ev.target.result.split(',')[1];
          // Prefix the saved filename with the product so each file is
          // self-describing inside the Drive folder.
          var savedName = (addonForProduct ? addonForProduct + ' – ' : '') + file.name;
          resolve({ filename: savedName, mimeType: file.type || 'application/octet-stream', data: base64 });
        };
        reader.readAsDataURL(file);
      });
    }

    function uploadFiles(fileList) {
      if (!driveUrl) return;
      var accepted = [];
      Array.prototype.slice.call(fileList).forEach(function (file) {
        var ext = fileExt(file.name);
        if (ALLOWED_EXT.indexOf(ext) === -1) {
          rejectFile(file.name, ext);
        } else {
          accepted.push(file);
        }
      });
      if (accepted.length) clearUploadError();
      accepted.forEach(function (file) {
        var row = renderRow(file.name);
        var p = readAsPayload(file)
          .then(function (payload) {
            return fetch(driveUrl, {
              method: 'POST',
              body: JSON.stringify({ files: [payload], folder: driveFolder }),
              redirect: 'follow',
              headers: { 'Content-Type': 'text/plain' }
            });
          })
          .then(function (res) { return res.json(); })
          .then(function (result) {
            if (result && result.success && result.files && result.files.length) {
              var f = result.files[0];
              row.setDone(f.filename + ': ' + f.url);
            } else {
              row.setError();
            }
          })
          .catch(function () { row.setError(); });
        pendingUploads.push(p);
      });
    }

    if (uploadWrap && fileInput) {
      if (dropBtn) dropBtn.addEventListener('click', function () { fileInput.click(); });
      fileInput.addEventListener('change', function () {
        uploadFiles(fileInput.files);
        fileInput.value = '';
      });
      ['dragenter', 'dragover'].forEach(function (ev) {
        uploadWrap.addEventListener(ev, function (e) { e.preventDefault(); uploadWrap.classList.add('is-drag'); });
      });
      ['dragleave', 'drop'].forEach(function (ev) {
        uploadWrap.addEventListener(ev, function (e) { e.preventDefault(); uploadWrap.classList.remove('is-drag'); });
      });
      uploadWrap.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files) uploadFiles(e.dataTransfer.files);
      });
    }

    // ── Add-to-cart (main product + add-on line) ────────────────────────
    var form = document.querySelector('.product-single__form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      if (!checkbox.checked) return; // Checkbox off — let Impulse handle normally

      e.preventDefault();
      e.stopImmediatePropagation(); // Block Impulse's own submit handler

      var variantSelect = form.querySelector('[name="id"]');
      var quantityInput = form.querySelector('[name="quantity"]');
      var btn           = form.querySelector('[data-add-to-cart]');

      var mainVariantId = parseInt(variantSelect ? variantSelect.value : 0, 10);
      var quantity      = parseInt(quantityInput ? quantityInput.value : 1, 10) || 1;
      if (!mainVariantId) return;

      // Show loading state on ATC button
      var textEl = btn ? btn.querySelector('[data-add-to-cart-text]') : null;
      function setBtnLoading(loading) {
        if (!btn) return;
        btn.disabled = loading;
        btn.classList.toggle('btn--loading', loading);
        if (textEl) {
          textEl.textContent = loading ? '…' : (textEl.getAttribute('data-default-text') || 'Add to cart');
        }
      }
      setBtnLoading(true);
      clearAddError();

      // Wait for any in-flight uploads to finish so their links are attached
      // to the order.
      Promise.all(pendingUploads.map(function (p) { return p.catch(function () {}); }))
        .then(function () {
          // Artwork is required: no successful upload, no add-to-cart.
          if (uploadWrap && !uploadedLinks.length) {
            setBtnLoading(false);
            showUploadError();
            return;
          }

          // Pair the two lines with a shared hidden ref. branding-selector.js
          // reconciles the cart on every page load: a service line whose part
          // has been removed is removed with it, so the service can never be
          // left in the cart on its own.
          var ref = 'aref_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);

          var addonProps = { '_branding_ref': ref };
          if (addonForProduct) addonProps['Applies to'] = addonForProduct;
          if (uploadedLinks.length) addonProps[uploadProperty] = uploadedLinks.join('   |   ');

          // ONE request carrying both lines. /cart/add.js with an items array
          // is all or nothing: if the part cannot be added, the marking service
          // is not added either. This used to be two parallel adds racing on
          // the same cart, which could leave the service line standing alone.
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [
                { id: mainVariantId, quantity: quantity, properties: { '_branding_ref': ref } },
                { id: addonVariantId, quantity: 1, properties: addonProps }
              ]
            })
          })
            .then(function (res) {
              if (!res.ok) {
                return res.json().catch(function () { return {}; }).then(function (err) {
                  throw new Error(err.description || err.message || 'Add to cart failed');
                });
              }
              return fetch('/cart.js').then(function (r) { return r.json(); });
            })
            .then(function (cart) {
              updateCartCount(cart.item_count);
              document.dispatchEvent(new CustomEvent('cart:build'));
              openCartDrawer();
              setBtnLoading(false);
            });
        })
        .catch(function (err) {
          // Nothing was added (the multi-line add is atomic). Say so rather
          // than resubmitting, which would add the part without its service.
          setBtnLoading(false);
          addError(err && err.message ? err.message : null);
        });
    }, true); // capture phase — runs before Impulse's listener
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();